/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MenuItem/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function MenuItem({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/Content/Tabs/Content/MenuItem"
  
}) {
let menuItemTextValueData = fromData.useDataValue({ viewPath,
context: 'menu_item',
path: 'text',
})
let selectedUnreadCountValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'unread_count',
})
let aggregateData = fromHelpers.withCount(menuItemTextValueData, selectedUnreadCountValueData)
let selectedInboxTabIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'inbox_tab_id',
})
let menuItemIdValueData = fromData.useDataValue({ viewPath,
context: 'menu_item',
path: 'id',
})
let aggregateData1 = fromAggregate.equals(selectedInboxTabIdValueData, menuItemIdValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 textIndent="0px"
 size="medium"
 data="menu_item.text"
 data="selected.unread_count"
 aggregate="helpers.js withCount"
 text={aggregateData}
 onClick={onClick}
 data="selected.inbox_tab_id"
 data="menu_item.id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
/>
{children}
</React.Fragment>)
}